import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { redesSociais } from "config/linksInstitucionais";
import LinkExterno from "components/LinkExterno";

// Logotipo de cada rede, pelo `id` do config. Silhueta cheia sempre: logotipo se reconhece
// de relance pela forma, e desenhá-lo em contorno é o que tira isso dele. A cor da marca é
// o padrão, para fundo claro (Quem somos); o rodapé navy troca por uma cor só via
// `classeDoIcone`. O Instagram é um gradiente na marca; o rosa é a cor que a própria rede
// usa quando precisa de uma só.
const ICONE_REDE = {
  facebook: { Marca: FaFacebook, cor: "text-[#1877F2]" },
  instagram: { Marca: FaInstagram, cor: "text-[#E4405F]" },
  linkedin: { Marca: FaLinkedin, cor: "text-[#0A66C2]" },
  youtube: { Marca: FaYoutube, cor: "text-[#FF0000]" },
};

/**
 * Os perfis da Nova Faxina nas redes, um link por rede, lado a lado, só com o logotipo.
 *
 * Aparece em dois lugares que os desenham diferente — o rodapé como tile pequeno, o
 * Quem somos com o logotipo grande e solto — então o visual do link vem de fora, em
 * `classeDoLink`, o tamanho do ícone em `tamanhoIcone` e a distribuição da fileira em
 * `classeDaLista`. `classeDoIcone`, quando vem, substitui a cor de marca: o rodapé navy
 * desenha as quatro numa cor só (ver ICONE_CANAL no Footer); o Quem somos, sobre fundo
 * claro, não passa nada e fica com as cores de cada rede. O que é igual nos dois fica aqui: a lista (do config), o ícone de cada
 * rede, o nome acessível e o LinkExterno, sem o qual o `target="_blank"` numa WebView
 * carregaria o Facebook por cima do app.
 */
export default function RedesSociais({ classeDoLink = "", classeDaLista = "", classeDoIcone, tamanhoIcone = 20 }) {
  return (
    <ul className={`flex flex-wrap items-center gap-3 ${classeDaLista}`}>
      {redesSociais.map((rede) => {
        const { Marca, cor } = ICONE_REDE[rede.id];
        return (
          <li key={rede.id}>
            {/* Sem texto visível, o aria-label é tudo o que o leitor de tela tem — o svg
                vai aria-hidden. */}
            <LinkExterno
              href={rede.href}
              className={classeDoLink}
              aria-label={rede.nome}
              title={rede.nome}
            >
              <Marca size={tamanhoIcone} className={`shrink-0 ${classeDoIcone ?? cor}`} aria-hidden="true" />
            </LinkExterno>
          </li>
        );
      })}
    </ul>
  );
}
